import * as Yup from 'yup';
export const validationSchema = (name: string) =>
  Yup.object({
    name: Yup.string()
      .required('Este campo é obrigatório')
      .oneOf([name], 'Nome do canal não corresponde'),
  });
